import React, { useState, useEffect } from 'react'
import {
  Flex,
  Button,
  Title,
  SpacingVertical,
  GridCell,
  Grid,
  FormElement,
  Divider,
  INPUT_TEXT_VARIANT_DANGER,
  Link,
  InputText
} from 'mailup-web-components'
import styled from '@emotion/styled'
import iconSocial from '../../icons/cd-icon-social.svg'
import { useIntl } from 'react-intl'
import SocialSelect from 'Pages/EmailContentDefaults/shared/SocialSelect'
import IconDelete from 'Pages/EmailContentDefaults/shared/IconDelete'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import {
  pageState,
  styleState
} from 'Pages/EmailContentDefaults/recoil/state/state'
import PropTypes from 'prop-types'
import {
  DEFAULT_THEME,
  socialOptions,
  SOCIAL_LIST
} from 'Pages/EmailContentDefaults/shared/utils'

const StyleGrid = styled(Grid)`
  margin: 0 12px;
`

const StyleLink = styled(Link)`
  margin: 0 12px;
`

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  padding-right: 8px;
`

const StyleButtonCell = styled(GridCell)`
  align-items: end;
  display: flex;
`

const StyledButtonDelete = styled(Button)`
  span {
    margin-top: 6px !important;
  }
`

const SocialRow = ({ row, rows, alreadySelected }) => {
  const intl = useIntl()
  const setPageState = useSetRecoilState(pageState)
  const setRow = useSetRecoilState(styleState)
  const { isEnabled } = useRecoilValue(pageState)

  const [selectedSocial, setSelectedSocial] = useState('')

  useEffect(() => {
    if (selectedSocial) {
      setPageState(prev => ({
        ...prev,
        isDirty: true
      }))

      const index = rows.findIndex(e => e.name === row.name)
      const icons = rows.slice()
      const social = SOCIAL_LIST.find(e => e.name === selectedSocial)
      icons[index] = {
        ...row,
        name: selectedSocial,
        image: {
          ...row.image,
          prefix: social.image.prefix,
          alt: social.image.alt,
          src: social.image.src.replace('@@@replace@@@', icons[0].type),
          title: social.image.title,
          href: social.image.href
        },
        text: social.text
      }

      setRow(prev => ({
        ...prev,
        social: {
          ...prev.social,
          icons
        }
      }))
    }
  }, [selectedSocial])

  const onChangeSocialSelect = name => {
    setSelectedSocial(name)
  }
  const onInputLinkChange = e => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    let val = e.target.value
    if (!e.target.value) {
      // valore di default
      const s = SOCIAL_LIST.find(e => e.name === row.name)
      val = s.image.href
    }

    const index = rows.findIndex(e => e.name === row.name)
    const icons = rows.slice()
    icons[index] = {
      ...row,
      image: { ...row.image, href: val }
    }

    setRow(prev => ({
      ...prev,
      social: {
        ...prev.social,
        icons
      }
    }))
  }
  const onInputTextChange = e => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    // let val = e.target.value
    // if (!e.target.value) {
    //   // valore di default
    //   const s = SOCIAL_LIST.find(e => e.name === row.name)
    //   val = s.image.title
    // }

    const index = rows.findIndex(e => e.name === row.name)
    const icons = rows.slice()
    icons[index] = {
      ...row,
      text: e.target.value
      // image: { ...row.image, title: val }
    }

    setRow(prev => ({
      ...prev,
      social: {
        ...prev.social,
        icons
      }
    }))
  }

  const onDelete = () => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    const index = rows.findIndex(e => e.name === row.name)
    const icons = rows.slice()
    icons.splice(index, 1)

    setRow(prev => ({
      ...prev,
      social: {
        ...prev.social,
        icons
      }
    }))
  }

  return (
    <>
      <GridCell span={4}>
        <FormElement
          label={intl.formatMessage({
            id: 'Load.ContentDefaults.SocialLabel'
          })}
        >
          <SocialSelect
            disabled={!isEnabled}
            alreadySelected={alreadySelected}
            value={row.name}
            onChange={onChangeSocialSelect}
          />
        </FormElement>
      </GridCell>
      <GridCell span={4}>
        <FormElement
          label={intl.formatMessage({
            id: 'Load.ContentDefaults.SocialLinkLabel'
          })}
        >
          <Flex alignItems='center'>
            <InputText
              disabled={!isEnabled}
              placeholder={'https://...'}
              value={row.image.href}
              onChange={onInputLinkChange}
              data-mu-test='social-link-text'
            />
          </Flex>
        </FormElement>
      </GridCell>
      <GridCell span={3}>
        <FormElement
          label={intl.formatMessage({
            id: 'Load.ContentDefaults.SocialTextLabel'
          })}
        >
          <InputText
            disabled={!isEnabled}
            placeholder={''}
            value={row.text}
            onChange={onInputTextChange}
            data-mu-test='social-name-text'
          />
        </FormElement>
      </GridCell>
      <StyleButtonCell span={1}>
        <StyledButtonDelete
          disabled={!isEnabled}
          onClick={onDelete}
          kind='neutral'
        >
          <IconDelete />
        </StyledButtonDelete>
      </StyleButtonCell>
    </>
  )
}

SocialRow.propTypes = {
  row: PropTypes.object,
  rows: PropTypes.array,
  alreadySelected: PropTypes.array
}

const SocialElements = () => {
  const intl = useIntl()
  const {
    social: { icons }
  } = useRecoilValue(styleState)
  const setIcons = useSetRecoilState(styleState)
  const setPageState = useSetRecoilState(pageState)
  const { isEnabled } = useRecoilValue(pageState)

  return (
    <>
      <Flex alignItems='center'>
        <StyledIcon src={iconSocial} />
        <Title variant='M'>
          {intl.formatMessage({
            id: 'Load.ContentDefaults.SocialLabel'
          })}
        </Title>
      </Flex>
      {icons && icons.length > 0 && (
        <>
          <SpacingVertical variant='16' />
          <StyleGrid cols={12}>
            {icons.map((e, i) => (
              <SocialRow
                key={i}
                row={e}
                rows={icons}
                alreadySelected={icons.map(e => e.name)}
              />
            ))}
          </StyleGrid>
        </>
      )}
      <SpacingVertical />
      <StyleLink
        disabled={icons.length === socialOptions.length || !isEnabled}
        variant='default'
        onClick={() => {
          setPageState(prev => ({
            ...prev,
            isDirty: true
          }))

          // prendo il primo dispnibile
          // const alreadySelected = icons.map(e => e.name)
          // const sOptions = socialOptions.filter(
          //   e => !alreadySelected.find(x => x === e.value)
          // )

          const newIcons = icons.slice()
          newIcons.push({
            type: icons.length > 0 ? icons[0].type : DEFAULT_THEME,
            name: '',
            image: {
              prefix: '',
              alt: '',
              src: ``,
              title: '',
              href: ''
            },
            text: ''
          })

          setIcons(prev => ({
            ...prev,
            social: {
              ...prev.social,
              icons: newIcons
            }
          }))
        }}
      >
        {icons.length === 0 &&
          intl.formatMessage({ id: 'Load.ContentDefaults.SocialAddLink' })}
        {icons.length > 0 &&
          intl.formatMessage({ id: 'Load.ContentDefaults.SocialAddNewLink' })}
      </StyleLink>
      <SpacingVertical />
      <Divider />
      <SpacingVertical />
    </>
  )
}

export default SocialElements
